import { __ } from '@wordpress/i18n';
const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, TextControl, ToggleControl } = wp.components;

export default ({ attributes, setAttributes }) => {

  return (
    <InspectorControls>
      <PanelBody
        title="Opções de exibição"
        initialOpen={true}
      >
        <PanelRow>
          <ToggleControl
            label="Exibir titulo"
            checked={attributes.showTitle}
            onChange={(showTitle) => setAttributes({ showTitle })}
          />
        </PanelRow>
        <PanelRow>
          <ToggleControl
            label="Exibir subtítulo"
            checked={attributes.showSubtitle}
            onChange={(showSubtitle) => setAttributes({ showSubtitle })}
          />
        </PanelRow>
      </PanelBody>

      <PanelBody
        title="Controle do formulário"
        initialOpen={false}
      >
        <PanelRow>
          <TextControl
            label="ID do forumário"
            value={attributes.formId}
            onChange={(formId) => setAttributes({ formId })}
          />
        </PanelRow>
      </PanelBody>
    </InspectorControls>
  )
}
